export enum MarketplaceInformationTestIds {
  LOADER = 'market_info_loader',
}
